import { Equivalency } from '../../types/types';

export const getInitialCarbonEquivalencyState = (): Equivalency[] => {
  return [];
};
